import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import FilterSearch from './FilterSearch'
import { actions } from '../../../store'

const mapStateToProps = state => ({
  filters: state.storage.filters
})

const mapDispatchToProps = dispatch => bindActionCreators({
  setSearch: actions.storage.setSearch
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FilterSearch)



// WEBPACK FOOTER //
// ./src/components/Parts/FilterSearch/index.js